import activeUsersTemplate from './usersActiveWidget.html';
import './usersActiveWidget.scss';

export default angular
  .module('main.dashboardPanel.usersActiveWidget', [])

  .directive('usersActiveWidget', () => {
    return {
      restrict: 'E',
      template: activeUsersTemplate,
      scope: {},
      controller: ($scope,
                   utils,
                   DashboardDataProvider) => {
        $scope.noData = false;
        init();

        function init() {
          $scope.loading = true;

          DashboardDataProvider.getUsersLastWeek()
            .then((reportInfo) => {
              $scope.loading = false;
              if (!reportInfo || !reportInfo.dictionary || reportInfo.dictionary.length <= 0 || !reportInfo.executions || reportInfo.executions.length <= 0) {
                $scope.noData = true;
                return;
              }

              let executions = reportInfo.executions
                .slice()
                .sort((a, b) => a.executionDateMs - b.executionDateMs) // latest last
                .map(execution => ({
                  ...execution,
                  mau: execution.data?.find((d) => d.id === 4)?.value
                }));

              let lastExecution = executions[executions.length - 1];
              if (!lastExecution.data) {
                $scope.noData = true;
                return;
              }

              $scope.trend = DashboardDataProvider.calculateTrend(executions, 'mau');
              $scope.trendDate = new Date(executions[0].executionDateMs);
              $scope.usersMau = lastExecution.mau;
            }, (err) => {
              utils.handleApiError(err);
              $scope.noData = true;
              $scope.loading = false;
            });
        }
      }
    };
  })
  .name;
